import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getErrorMessage } from '../../../api';
import { getBookingRenderApiV2, getPrintBookingApi } from '../../../api/booking';
import { Constant } from '../../../config/constant';
import { BookingInfoState, BookingsState, PrintBookingParams } from '../../../types/booking';
import { RootState } from '../../store';
// @ts-ignore

export const getBookingRenderV2 = createAsyncThunk(
  'admin/bookingInfoV2/render',
  async (params: BookingInfoState, { dispatch, rejectWithValue }) => {
    try {
      const response = await getBookingRenderApiV2(params);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListBookingRender(data));
        return true;
      }
    } catch (error: any) {
      const { response } = error;
      if (response?.data?.message === 'Không tìm thấy thông tin chuyến') {
        dispatch(resetListBookingRender());
      }
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);
export const getPrintBooking = createAsyncThunk(
  'admin/bookingInfoV2/printBooking',
  async (params: PrintBookingParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await getPrintBookingApi(params);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListBookingPrint(data));
        return true;
      }
    } catch (error: any) {
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);

export const listBookingRenderSlice = createSlice({
  name: 'listBookingRender',
  initialState: {
    error: false,
    loading: false,
    success: false,
    pagination: [],
    paginationHistory: [],
    status: 0,
    errorDetail: null,
    message: '',
    listBookingRender: [],
    listDataBookingPrint: [],
    isShowNewBooking: true,
  } as BookingsState,
  reducers: {
    setListBookingRender: (state: BookingsState, { payload }) => {
      state.listBookingRender = payload?.data;
      state.bookingData = payload?.data?.booking?.data;
    },
    setListBookingPrint: (state: BookingsState, { payload }) => {
      state.listDataBookingPrint = payload?.data;
    },
    resetListBookingRender: (state: BookingsState) => {
      state.listBookingRender = [];
      state.bookingData = [];
    },
    setIsShowNewBooking: (state: BookingsState, { payload }) => {
      state.isShowNewBooking = payload;
    },
    resetLoadingBookingRender: (state: BookingsState) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBookingRenderV2.pending, (state: BookingsState, action) => {
      if (action?.meta?.arg?.detectLoading) {
        state.loading = false;
      } else {
        state.loading = true;
      }
    });
    builder.addCase(getBookingRenderV2.fulfilled, (state: BookingsState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getBookingRenderV2.rejected, (state: BookingsState) => {
      state.loading = false;
      state.success = false;
      state.error = true;
    });
  },
});

export const listBookingRenderSelector = (state: RootState) => state.listBookingRender;
export const {
  setListBookingRender,
  resetListBookingRender,
  setIsShowNewBooking,
  resetLoadingBookingRender,
  setListBookingPrint,
} = listBookingRenderSlice.actions;
